import { render, staticRenderFns } from "./gj-brand-select.vue?vue&type=template&id=a94250d0&scoped=true&"
import script from "./gj-brand-select.vue?vue&type=script&lang=js&"
export * from "./gj-brand-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-brand-select.vue?vue&type=style&index=0&id=a94250d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94250d0",
  null
  
)

export default component.exports